module.exports = __webpack_public_path__ + "img/max20.80007ed0.png";